<template>
  <div class="getway-control-manage">
    <div class="scene-detail-area flex-auto">
      <template>
        <div class="getway-control-middle">
          <GetawayDetail ref="getwayDetail"></GetawayDetail>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GetawayDetail from "@/modules/gatewayManager/components/GetwayDetail";
export default {
  components: {
    GetawayDetail,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="scss">
.app-side-panel__header {
  .title {
    padding: 0px 6px;
    border-left: 4px solid #407aee;
    margin-left: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.getway-control-manage {
  width: 100%;
  display: flex;
  height: 100%;
  padding: 0 16px;
  .getway-add-fade-enter-active,
  .getway-add-fade-leave-active {
    transition: opacity 0.2s;
  }
  .getway-add-fade-enter,
  .getway-add-fade-leave-to {
    opacity: 0;
  }
  .card-info-panel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @include set_theme_color(background-color, menu-tab-bg-color);
  }
  .scene-detail-area {
    width: 100%;
    display: flex;
  }
  .card-info-header {
    padding: 0 15px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include set_theme_color(background-color, table-header-bg-color);
  }

  .card-info-body {
    flex: 1;
    overflow: hidden;
  }

  .getway-control-left {
    width: 350px;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    @include set_theme_color(background-color, menu-tab-bg-color);
    .getway-control-tree {
      padding: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
  .getway-control-middle {
    width: 100%;
    // margin-left: 10px;
    // padding-right: 10px;
    position: relative;
  }
  .getway-control-right {
    width: 350px;
    flex: 0 0 auto;
  }
  .getway-control-option {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .edit-scene-info {
    padding: 10px;
  }

  .no-scene-area {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include set_theme_color(background-color, menu-tab-bg-color);
    margin-left: 10px;

    .no-scene-text {
      @include set_theme_color(color, font-disabled-color);
      margin-bottom: 10px;
    }
  }
}
</style>
